// Layout Configuration
// This file allows you to easily switch between different dashboard and navigation layouts

import { useTheme, useMediaQuery } from '@mui/material';

export const LAYOUT_CONFIG = {
  // Set to 'original' or 'simplified' to switch layouts
  DASHBOARD_LAYOUT: 'original' as 'original' | 'simplified',
  NAVIGATION_LAYOUT: 'original' as 'original' | 'simplified',
  
  // Feature flags for enabling/disabling specific features
  FEATURES: {
    VOICE_ASSISTANT: true,
    DARK_MODE: true,
    OFFLINE_SUPPORT: true,
    PWA_FEATURES: true,
    ONBOARDING: true,
    FORCE_MOBILE_LAYOUT: false, // New: Allow users to choose desktop layout on mobile
  },
  
  // Dashboard configuration
  DASHBOARD: {
    SHOW_HEALTH_SCORE: true,
    SHOW_QUICK_ACTIONS: true,
    SHOW_TODAYS_OVERVIEW: true,
    SHOW_RECENT_ACTIVITY: true,
    SHOW_NAVIGATION_CARDS: true,
    COMPACT_MODE: false, // Reduces spacing and card sizes
  },
  
  // Navigation configuration
  NAVIGATION: {
    DRAWER_WIDTH: 280,
    SHOW_DESCRIPTIONS: true,
    GROUP_ITEMS: true,
    SHOW_BADGES: true,
    COLLAPSIBLE_SECTIONS: true,
  },
  
  // Standardized responsive breakpoints - CRITICAL FIX
  BREAKPOINTS: {
    MOBILE: 'sm',      // Use 'sm' consistently across app
    TABLET: 'md',
    DESKTOP: 'lg',
    // Pixel values for reference
    MOBILE_PX: 600,
    TABLET_PX: 900,
    DESKTOP_PX: 1200,
  }
};

// STANDARDIZED responsive utilities to prevent inconsistent breakpoint usage
export const useResponsive = () => {
  const theme = useTheme();
  
  // CRITICAL: Use consistent breakpoints across entire app
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Use literal string for now
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md')); // For compatibility
  
  // Smart layout detection - Force mobile layout for mobile-first design
  const shouldUseMobileLayout = isMobile || isTablet || LAYOUT_CONFIG.FEATURES.FORCE_MOBILE_LAYOUT;
  const canUseDesktopFeatures = isDesktop && !shouldUseMobileLayout;
  
  return { 
    isMobile, 
    isTablet, 
    isDesktop, 
    isMobileOrTablet,
    shouldUseMobileLayout,
    canUseDesktopFeatures 
  };
};

// Helper function to check if simplified layout is enabled
export const isSimplifiedLayout = () => {
  return LAYOUT_CONFIG.DASHBOARD_LAYOUT === 'simplified' || 
         LAYOUT_CONFIG.NAVIGATION_LAYOUT === 'simplified';
};



// Helper function to get the appropriate navigation component
export const getNavigationComponent = () => {
  return LAYOUT_CONFIG.NAVIGATION_LAYOUT === 'simplified' 
    ? 'SimplifiedNavigation' 
    : 'Layout';
};

export default LAYOUT_CONFIG; 